const AttachmentName = (nameOnServer) => {
  let serverDelimitter = "_";

  if (nameOnServer?.includes(serverDelimitter)) {
    let [first, ...rest] = nameOnServer.split(serverDelimitter);
    return nameOnServer.replace(first + serverDelimitter, "");
  }
  return nameOnServer;
};

export default AttachmentName;
